import { Button, Alert } from 'reactstrap';
import {
  useTranslator,
  withMobileAppMode,
  callNativeMobileApp,
  useAppContext,
} from '@front-activerse/common-components';
import { useNavigate } from 'react-router-dom';

const GoalAlert = ({ goal, mobileAppMode }) => {
  const { t } = useTranslator();
  const navigate = useNavigate();
  const {
    consts: { FIRST_GOAL_SETTINGS_STEP_SLUG },
  } = useAppContext();

  const handleGoalBtn = () => {
    if (mobileAppMode) {
      callNativeMobileApp({
        action: 'open_modal',
        payload: {
          path: `/diet-settings/goalSettings/${FIRST_GOAL_SETTINGS_STEP_SLUG}`,
          modal_variant: 'always_close_btn',
        },
      });
    } else {
      navigate(`/diet-settings/goalSettings/${FIRST_GOAL_SETTINGS_STEP_SLUG}`);
    }
  };

  if (goal) {
    if (goal.lostBecauseOfLoseWeight || goal.lostBecauseOfPutOnWeight) {
      return (
        <Alert color="warning" fade={false}>
          <p className="small mb-l">{t('mealPlan.goalLost.notification.content')}</p>
          <div className="text-center">
            <Button
              color="primary"
              size="sm"
              onClick={handleGoalBtn}
              // onClick={() =>
              //   trackFirebaseEvent('user_action', {
              //     action: 'tap-set_goal',
              //     location: 'Dietplan',
              //   })
              // }
            >
              {t('mealPlan.goalLost.notification.button')}
            </Button>
          </div>
        </Alert>
      );
    }

    if (goal.reachedBecauseOfLoseWeight || goal.reachedBecauseOfPutOnWeight) {
      return (
        <Alert color="success" fade={false}>
          <p className="small mb-l">{t('mealPlan.goalReached.notification.content')}</p>
          <div className="text-center">
            <Button
              color="primary"
              size="sm"
              onClick={handleGoalBtn}
              // onClick={() =>
              //   trackFirebaseEvent('user_action', {
              //     action: 'tap-set_goal',
              //     location: 'Dietplan',
              //   })
              // }
            >
              {t('mealPlan.goalReached.notification.button')}
            </Button>
          </div>
        </Alert>
      );
    }
  }

  return '';
};

export default withMobileAppMode(GoalAlert);
